import React from 'react';
import { KatInput, KatButton } from '@amzn/katal-react';

interface SiteSelectorProps {
    onSiteSelect: (siteIds: string[]) => void;
}

export const SiteSelector: React.FC<SiteSelectorProps> = ({
    onSiteSelect
}) => {
    const handleAllChanges = () => {
        const inputElement = document.getElementById('multiSiteSelectInput') as HTMLInputElement;

        if (inputElement) {
            const newSiteIds = inputElement.value
                .split(',')
                .map(site => site.trim())
                .filter(site => site.length > 0);

            onSiteSelect(newSiteIds);
        }
    };

    return (
        <div className="multi-site-selection-container">
            <KatInput
                type='text'
                placeholder={"Comma separated list of FCs: OAK4, BFI4"}
                id='multiSiteSelectInput'
            />
            <KatButton onClick={handleAllChanges}>Select site</KatButton>
        </div>
    );
};